// src/components/ProtectedRoute.tsx
import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: string[];       // 🆕 Optional: bisa spesifik role atau tidak
  redirectPath?: string;         // 🆕 Optional: redirect jika tidak punya role
}

export default function ProtectedRoute({
  children,
  allowedRoles,
  redirectPath = "/unauthorized",
}: ProtectedRouteProps) {
  const { user } = useAuth();

  // Belum login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Login, tapi tidak termasuk allowed role
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={redirectPath} replace />;
  }

  // Boleh masuk
  return <>{children}</>;
}
